import { queryClient } from "App";
import { get } from "lodash";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  getCampaignStatusPresetsTableColumns,
  getCampaignStatusPresetsTableFilters,
} from "routes/campaign_status_presets/CampaignStatusPresetsTableColumnsAndFilters";
import { CAMPAIGN_STATUS_PRESETS_TABLE_CONSTANTS } from "routes/campaign_status_presets/CampaignStatusPresetsTableV3";
import UserService from "services/User";
import { addResizedColumns } from "./useTableConfig";

export const invalidateCampaignStatusPresetsTableQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [CAMPAIGN_STATUS_PRESETS_TABLE_CONSTANTS.queryKey],
  });
};

export const useCampaignStatusPresetsTable = ({ tableName = null }) => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const filters = useMemo(() => {
    return getCampaignStatusPresetsTableFilters();
  }, []);

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getCampaignStatusPresetsTableColumns();

    const campaignStatusPresetsTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: campaignStatusPresetsTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableName, tableSettings, isTableSettingsFetched]);

  return { filters, columns };
};
